import React from 'react';

class Header extends React.Component {
    constructor(props) {
        super(props);
        this.state = {
            isSearchOpen: false,
            isActive: 'All',
        };
    }
    showSearchBar = (e) => {
        this.setState({ isSearchOpen: true });
    };
    hideSearchBar = (e) => {
        this.setState({ isSearchOpen: false });
    };
    activeTab = (tab) => {
        this.setState({
            isActive: tab,
        });
    };
    render() {
        let { isSearchOpen, isActive } = this.state;
        return (
            <div>
                {isSearchOpen ? (
                    <div className="casino__header disable-select mb-2">
                        <div className="search-input">
                            <input id="search-input" autoFocus />
                            <label ForHtml="search-input" className="icon-search search-input__icon"></label>
                        </div>
                        <div className="ml-2 pt-2">
                            <i className="material-icons" onClick={this.hideSearchBar}>
                                close
                            </i>
                        </div>
                    </div>
                ) : (
                    <div className="casino__header disable-select mb-2" style={{ overflowX: 'auto' }}>
                        <div className="divbox mr-0" onClick={this.showSearchBar}>
                            <i className="icon-search"></i>
                        </div>
                        <div className={`divbox divbox_min-width ${isActive === 'All' ? 'divbox_active' : ''}`} onClick={(e) => this.activeTab('All')}>
                            <span>All</span>
                        </div>
                        <div className={`divbox ${isActive === 'Netent' ? 'divbox_active' : ''}`} onClick={(e) => this.activeTab('Netent')}>
                            <span>Netent</span>
                        </div>
                        <div className={`divbox ${isActive === 'Novoline' ? 'divbox_active' : ''}`} onClick={(e) => this.activeTab('Novoline')}>
                            <span>Novoline</span>
                        </div>
                        <div className={`divbox ${isActive === 'EGT' ? 'divbox_active' : ''}`} onClick={(e) => this.activeTab('EGT')}>
                            <span>EGT</span>
                        </div>
                        <div className={`divbox ${isActive === 'BTF' ? 'divbox_active' : ''}`} onClick={(e) => this.activeTab('BTF')}>
                            <span>BTF</span>
                        </div>
                    </div>
                )}
            </div>
        );
    }
}

export default Header;
